/**
 * Graph click handlers pass a DOM event into `updateActive`, while board restore,
 * tutorials, and Flowy focus pass the node object itself. Only the former is a
 * genuine user click that should feed back into Flowy's behaviour tree.
 */
export const isUserInitiatedNodeActivation = (eventOrNode: unknown): boolean => {
	if (!eventOrNode || typeof eventOrNode !== 'object') return false;
	return !('uid' in eventOrNode);
};
